import { PixiBase } from '../../core/pixi/PixiBase';
import { canvasTranslationKeys } from '../../enums';
import { menuBarStore } from '../../store/menuBarStore';
import { containerNames, frameNames } from '../../constants';
import { enterFullscreen, exitFullscreen, setContainersPosition } from '../../helpers';
import { isMobile } from '../../helpers/isMobile';
import { gameMainDrawer } from './gameMainDrawer';
import {
  SOUND_MOBILE_RANGE_MAX_MIN_Y,
  SOUND_RANGE_MAX_MIN_Y,
  SOUND_RANGE_VALUE,
} from '../../core/constants';
import { applicationStore } from '../../store/applicationStore';
import { gameStore } from '../../store/gameStore';
import { userInfoStore } from '../../store/userInfoStore';
import { iframeService } from '../../services/iframeService';
import { spinBarStore } from '../../store/spinBarStore';
import { updateDate } from '../../helpers/gameDate';
import { userSettingsStore } from '../../store/userSettingsStore';
import { isoStandard } from '../../helpers/isoStandard';
import { Spine } from '../../services/elementTypeService/Spine';
import { boostedJackpotStore } from '../../store/boostedJackpotStore';

export class MenuBarDrawer {
  constructor() {
    this.animations = {};
    this.MenuBarContainer = PixiBase.createContainer(containerNames.MenuBarContainer);
    this.menuBarPopupContainer = PixiBase.createContainer(containerNames.MenuBarPopupContainer);
    this.iconsAndTextContainer = PixiBase.createContainer(containerNames.IconsAndTextContainer);
    this.menuBarWrapperContainer = PixiBase.createContainer(containerNames.MenuBarWrapperContainer);
    this.soundControllerWrapper = PixiBase.createContainer(containerNames.SoundControllerWrapper);
    this.graphicsContainer = PixiBase.createContainer('graphicsContainer4');
    this.isDragging = false;
    this.isButtonPressed = false;
    this.soundRangeValues = isMobile() ? SOUND_MOBILE_RANGE_MAX_MIN_Y : SOUND_RANGE_MAX_MIN_Y;
  }

  setupMenuBarWrapper() {
    this.menuBarWrapper = PixiBase.createSprite(this.spriteSheet.menuBarWrapper);
    const { x, y } = this.config.BetBarContainer.menuBarWrapperConfig;
    PixiBase.setPosition(this.menuBarWrapper, { x: x, y: y });
    this.menuBarWrapperContainer.addChild(this.menuBarWrapper);
  }

  setupBalanceText(text = gameStore.canvasTranslationKeys.BALANCE) {
    this.balanceText = PixiBase.createText(`${text}: `, {
      fontSize: 18,
      fill: 'white',
      align: 'center',
      fontWeight: 400,
      fontFamily: 'Roboto',
    });
    const { x, y, anchor } = this.config.BetBarContainer.balanceTextConfig;
    PixiBase.setPosition(this.balanceText, { x: x, y: y });
    this.balanceText.anchor.set(anchor);
    this.menuBarWrapperContainer.addChild(this.balanceText);
    this.MenuBarContainer.addChild(this.menuBarWrapperContainer);
  }

  setupBalanceAmount() {
    this.balanceAmount = PixiBase.createText('', {
      fontSize: 18,
      fill: '#FFD880',
      align: 'center',
      fontWeight: 400,
      fontFamily: 'Roboto',
    });
    const { y, anchor } = this.config.BetBarContainer.balanceAmountConfig;
    PixiBase.setPosition(this.balanceAmount, {
      x: Math.ceil(
        this.balanceText.x + (this.balanceText.width - this.balanceAmount.width) / 2 + 5
      ),
      y: y,
    });
    this.balanceAmount.anchor.set(anchor);
    this.menuBarWrapperContainer.addChild(this.balanceAmount);
  }

  updateUserBalance(tournamentId = null) {
    if (!tournamentId) {
      this.balanceAmount.text = isoStandard(userInfoStore.balance);
    }
  }

  isShowMobileIntroView(bool) {
    this.logoWrapper.visible = bool;
    this.mobileViewContainer.visible = bool;
  }

  openMobileSettings() {
    this.iconsList.forEach((el) => {
      if (el.frameName === frameNames.InfoIcon) {
        PixiBase.changeFrame(el, this.selectedIconsState[el.frameName]);
      } else {
        PixiBase.changeFrame(el, el.frameName);
      }
    });
    // gameMainDrawer.introBar.stepsCount = 0;
  }

  setupMobileSettingsIcon() {
    const iconsWrapper = PixiBase.createContainer(containerNames.MobileIconsWrapper);
    this.mobileIconsWrapper = iconsWrapper;
    this.iconsName = {
      [frameNames.InfoIcon]: gameStore.canvasTranslationKeys.PAYTABLE,
      [frameNames.SettingsIcon]: gameStore.canvasTranslationKeys.SETTINGS,
      [frameNames.GameRulesIcon]: gameStore.canvasTranslationKeys.GAME_RULES,
    };

    this.selectedIconsState = {
      [frameNames.InfoIcon]: frameNames.InfoIconSelected,
      [frameNames.SettingsIcon]: frameNames.SettingsIconSelected,
      [frameNames.GameRulesIcon]: frameNames.GameRulesIconSelected,
    };

    this.iconByContainerName = {
      [frameNames.InfoIcon]: containerNames.PayTableContainersWrapper,
      [frameNames.SettingsIcon]: containerNames.SettingsBarContainer,
      [frameNames.GameRulesIcon]: containerNames.GameRulesContainer,
    };
    this.iconsList = [];
    const menuIcons = [frameNames.InfoIcon, frameNames.GameRulesIcon];
    menuIcons.forEach((frameName, index) => {
      const iconContainer = PixiBase.createContainer(containerNames.IconContainer);
      const iconText = PixiBase.createText(this.iconsName[frameName], {
        fontSize: 17,
        fill: 'white',
        align: 'center',
        fontWeight: 510,
        fontFamily: 'Roboto',
      });
      const icon = PixiBase.createSprite(this.spriteSheet[frameName]);
      icon.frameName = frameName;
      iconContainer.frameName = frameName;
      iconContainer.icon = icon;
      this.iconsList.push(icon);
      PixiBase.setPosition(iconContainer, { x: 20 + index * (icon.width + 50), y: 0 });
      iconText.style.fontSize = 18 * Math.min((icon.width - 10) / iconText.width, 1);
      iconContainer.addChild(icon);
      PixiBase.setPosition(iconText, {
        x: Math.floor((iconContainer.width - iconText.width) / 2),
        y: 31,
      });
      PixiBase.setupButtonMode(iconContainer, { interactive: true, buttonMode: true });
      if (!index) {
        PixiBase.changeFrame(iconContainer, frameNames.InfoIconSelected);
      }
      PixiBase.registerClick(iconContainer, (e) => {
        PixiBase.changeFrame(e.target.icon, this.selectedIconsState[e.target.frameName]);
        gameMainDrawer.introBar.handleVisibilityContainersByName(
          this.iconByContainerName[e.target.frameName]
        );
        this.iconsList.forEach((el) => {
          if (el.frameName !== e.target.frameName) {
            PixiBase.changeFrame(el, el.frameName);
          }
        });
      });
      iconContainer.addChild(iconText);
      iconsWrapper.addChild(iconContainer);
    });
    const { x: iconX, y: iconsY } = this.config.MenuBarContainer.settingsIconsWrapper;
    PixiBase.setPosition(this.mobileIconsWrapper, { x: iconX, y: iconsY });
    this.mobileViewContainer.addChild(iconsWrapper);
  }

  setupMobileCloseIcon() {
    this.closeMenuIcon = PixiBase.createSprite(this.spriteSheet.burger);
    const { x: closeIconX, y: closeIconY } = this.config.MenuBarContainer.closeMenuBarIcon;
    PixiBase.setPosition(this.closeMenuIcon, { x: closeIconX, y: closeIconY });
    PixiBase.setupButtonMode(this.closeMenuIcon, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.closeMenuIcon, (e) => {
      this.isButtonPressed = true;
      PixiBase.changeFrame(e.target, frameNames.BurgerPressed);
    });
    PixiBase.registerPointerup(this.closeMenuIcon, (e) => {
      if (this.isButtonPressed) {
        const freeBetCount = gameStore.tournamentInfoInitial?.freeBetCount
          ? gameStore.tournamentInfoInitial?.freeBetCount
          : spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex]?.remainingCount;
        gameMainDrawer.freeBetBar.toggleVisibilityFreeBetCountContainer(
          menuBarStore.isMenuPopupOpen && Boolean(freeBetCount)
        );
        gameMainDrawer.introBar.handlePlayButtonFunctional();
        gameMainDrawer.introBar.handleVisibilityContainersByName();
        this.menuWrapperShadow.visible = true;
      }
      this.isButtonPressed = false;
      PixiBase.changeFrame(e.target, frameNames.Burger);
    });
    PixiBase.registerPointerout(this.closeMenuIcon, (e) => {
      this.isButtonPressed = false;
      PixiBase.changeFrame(e.target, frameNames.Burger);
    });
    this.mobileViewContainer.addChild(this.closeMenuIcon);
  }

  setupMobileMenuLogo() {
    this.logoWrapper = PixiBase.createContainer(containerNames.MobileLogoWrapper);
    const { x, y } = this.config.MenuBarContainer.logoWrapperContainer;
    PixiBase.setPosition(this.logoWrapper, { x, y });
    this.mobileMenuLogo = PixiBase.createSprite(this.spriteSheet.gameLogo);
    this.logoWrapper.addChild(this.mobileMenuLogo);
    this.logoWrapper.visible = false;
  }

  setupHomeButton() {
    this.homeButtonWrapper = PixiBase.createContainer(containerNames.HomeButtonWrapper);
    this.homeButton = PixiBase.createSprite(this.spriteSheet.homeIcon);
    this.homeText = PixiBase.createText(canvasTranslationKeys.HOME, {
      fontSize: 20,
      fill: 'white',
      align: 'center',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });
    const { x, y, anchor } = this.config.MenuBarContainer.homeButtonConfig;
    const { x: homeTextX, y: homeTextY } = this.config.MenuBarContainer.homeTextConfig;
    PixiBase.setPosition(this.homeButton, { x: x, y: y });
    PixiBase.setPosition(this.homeText, {
      x: homeTextX,
      y: homeTextY,
      anchor: anchor,
    });
    this.homeButton.anchor.set(anchor);
    this.homeText.anchor.set(anchor);
    this.homeButtonWrapper.addChild(this.homeButton);
    this.homeButtonWrapper.addChild(this.homeText);
    PixiBase.setupButtonMode(this.homeButtonWrapper, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.homeButtonWrapper, () => {
      iframeService.redirectHome();
    });
    this.mobileViewContainer.addChild(this.homeButtonWrapper);
  }

  createMobileIntroView() {
    this.mobileViewContainer = PixiBase.createContainer(containerNames.MobileViewContainer);
    this.mobileViewContainer.visible = false;
    this.MenuBarContainer.addChild(this.mobileViewContainer);
    this.setupMobileSettingsIcon();
    this.setupMobileCloseIcon();
    this.setupMobileMenuLogo();
    this.setupHomeButton();
    this.setupMobilMenuGameLogo();
  }

  setupMobilMenuGameLogo() {
    this.mobilMenuGameLogoContainer = PixiBase.createContainer(
      containerNames.MobilMenuGameLogoContainer
    );
    this.menuGameLogo = new Spine({ key: 'logo' });
    this.menuGameLogo.play('animation', true);
    const { x, y } = this.config.MenuBarContainer.menuGameLogo;

    PixiBase.setPosition(this.menuGameLogo, { x: x, y: y });

    // this.menuGameLogo.anchor.set(anchor);

    this.mobilMenuGameLogoContainer.addChild(this.menuGameLogo);

    this.mobileViewContainer.addChild(this.mobilMenuGameLogoContainer);
  }

  toggleMenuIconOpacity() {
    this.openMenuIcon.alpha = spinBarStore.isSpinStart ? 0.6 : 1;
  }

  setupOpenMenuIcon() {
    this.openMenuIcon = isMobile()
      ? PixiBase.createSprite(this.spriteSheet.openMenuBarIconMobile)
      : PixiBase.createSprite(this.spriteSheet.openMenuBarIcon);
    const { x, y, anchor } = this.config.BetBarContainer.openMenuIconConfig;
    if (isMobile()) {
      this.openMenuIcon.scale.set(0.6);
    }
    PixiBase.setPosition(this.openMenuIcon, { x: x, y: y });
    this.openMenuIcon.anchor.set(anchor);
    PixiBase.setupButtonMode(this.openMenuIcon, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.openMenuIcon, () => {
      if (spinBarStore.isAutoBetStart || spinBarStore.isSpinStart) {
        return;
      }
      if (isMobile()) {
        this.menuBarWrapperContainer.visible = false;
        this.isShowMobileIntroView(true);
        this.openMobileSettings();
        gameMainDrawer.introBar.handleVisibilityContainersByName(
          containerNames.PayTableContainersWrapper
        );
      }
      this.soundControllerWrapper.visible = false;
      gameMainDrawer.introBar.handleVisibilityContainersByName(
        containerNames.PayTableContainersWrapper
      );
      !isMobile() && (this.dateContainer.visible = menuBarStore.isMenuPopupOpen);
      gameMainDrawer.notificationBar.NotificationContainer.visible = menuBarStore.isMenuPopupOpen;
      this.menuBarPopupContainer.visible = !menuBarStore.isMenuPopupOpen;
      applicationStore.setIsShowJackpot(false);
      gameMainDrawer.boostedJackpot.BoostedJackpotContainer.visible = false;
      if (menuBarStore.isMenuPopupOpen) {
        gameMainDrawer.introBar.handleVisibilityContainersByName();
        this.menuBarYellowLayer.y = this.iconsAndTextContainer.y + this.payTableIconTextY;
        applicationStore.setIsShowJackpot(applicationStore.hasJackPot);
        gameMainDrawer.boostedJackpot.BoostedJackpotContainer.visible = Boolean(
          boostedJackpotStore.isBoostedJackpot
        );
      }
      this.menuWrapperShadow.visible = menuBarStore.isMenuPopupOpen;
      const freeBetCount = gameStore.tournamentInfoInitial?.freeBetCount
        ? gameStore.tournamentInfoInitial?.freeBetCount
        : spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex]?.remainingCount;
      gameMainDrawer.freeBetBar.toggleVisibilityFreeBetCountContainer(
        menuBarStore.isMenuPopupOpen && Boolean(freeBetCount)
      );
      menuBarStore.menuPopupToggle();
      this.setIntroBarVisibleState();
      const closeMenuBarIcon = isMobile()
        ? frameNames.CloseMenuBarIconMobile
        : frameNames.CloseMenuBarIcon;

      const openMenuBarIcon = isMobile()
        ? frameNames.OpenMenuBarIconMobile
        : frameNames.OpenMenuBarIcon;

      PixiBase.changeFrame(
        this.openMenuIcon,
        menuBarStore.isMenuPopupOpen ? closeMenuBarIcon : openMenuBarIcon
      );
    });
    this.menuBarWrapperContainer.addChild(this.openMenuIcon);
  }

  documentFullScreenChange() {
    document.addEventListener('fullscreenchange', () => {
      PixiBase.changeFrame(
        this.fullScreenIcon,
        window.innerHeight === window.screen.height
          ? frameNames.CloseFullScreenIcon
          : frameNames.FullScreenIcon
      );
    });
  }

  setupFullScreenIcon() {
    this.fullScreenIcon = PixiBase.createSprite(this.spriteSheet.fullScreenIcon);
    const { x, y, anchor } = this.config.BetBarContainer.fullScreenIconConfig;
    PixiBase.setPosition(this.fullScreenIcon, { x: x, y: y });
    this.fullScreenIcon.anchor.set(anchor);
    this.documentFullScreenChange();
    this.menuBarWrapperContainer.addChild(this.fullScreenIcon);
    PixiBase.setupButtonMode(this.fullScreenIcon, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.fullScreenIcon, () => {
      menuBarStore.fullScreenToggle();
      PixiBase.changeFrame(
        this.fullScreenIcon,
        menuBarStore.isFullScreen ? frameNames.CloseFullScreenIcon : frameNames.FullScreenIcon
      );
      window.innerHeight === window.screen.height
        ? exitFullscreen(this.fullScreenIcon)
        : enterFullscreen(this.fullScreenIcon);
    });
  }

  setupSoundIcon() {
    this.soundIcon = isMobile()
      ? PixiBase.createSprite(this.spriteSheet.soundIconMobile)
      : PixiBase.createSprite(this.spriteSheet.soundIcon);
    const { x, y, anchor } = this.config.BetBarContainer.soundIconConfig;
    if (isMobile()) {
      this.soundIcon.scale.set(0.6);
    }
    PixiBase.setPosition(this.soundIcon, { x: x, y: y });
    this.soundIcon.anchor.set(anchor);
    PixiBase.setupButtonMode(this.soundIcon, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.soundIcon, () => {
      menuBarStore.soundIconToggle();
      this.soundControllerWrapper.visible = true;
      // const { y: fillLineY } = this.config.MenuBarContainer.soundControllerLineConfig;
      const { y: graphicsY } = this.config.MenuBarContainer.soundControllerLineFillGraphics;

      if (userSettingsStore.soundValue > 0) {
        userSettingsStore.setSoundValue(0);
        this.volumeFillStateGraphics.position.y = graphicsY;
        PixiBase.changeFrame(
          this.soundIcon,
          isMobile() ? frameNames.MuteIconMobile : frameNames.MuteIcon
        );
        this.soundController.position.y = this.soundRangeValues.Max;
      } else {
        userSettingsStore.setSoundValue(userSettingsStore.prevSoundValue);
        this.soundController.position.y =
          this.soundRangeValues.Max +
          ((this.soundRangeValues.Min - this.soundRangeValues.Max) *
            userSettingsStore.prevSoundValue) /
            10;
        PixiBase.changeFrame(
          this.soundIcon,
          isMobile() ? frameNames.SoundIconMobile : frameNames.SoundIcon
        );
        this.volumeFillStateGraphics.position.y = graphicsY - userSettingsStore.prevSoundValue * 12;
      }
      PixiBase.setupButtonMode(this.graphics, { interactive: true, buttonMode: true });
    });
    this.menuBarWrapperContainer.addChild(this.soundIcon);
  }

  setupSoundProgressControllerGraphicsForMouseMove() {
    const graphics = PixiBase.createGraphics();
    this.graphics = graphics;
    graphics.beginFill('red');
    graphics.alpha = 0;
    graphics.drawRect(-60, -810, isMobile() ? 540 : 1500, isMobile() ? 960 : 830);
    graphics.endFill();
    PixiBase.registerPointerMove(graphics, this.onHandleDragMove.bind(this));
    PixiBase.registerPointerup(graphics, this.onHandleDragEnd.bind(this));
    PixiBase.registerPointerUpOutside(graphics, this.onHandleDragEnd.bind(this));
    PixiBase.registerClick(graphics, this.onHandleDragEnd.bind(this));
    this.graphicsContainer.addChild(graphics);
    this.soundControllerWrapper.addChild(this.graphicsContainer);
  }

  setupSoundControllerLine() {
    this.graphicsContainerMask = PixiBase.createContainer('graphicsContainerMask');
    this.soundControllerLine = PixiBase.createSprite(this.spriteSheet.soundControllerLine);
    this.volumeFillState = PixiBase.createSprite(this.spriteSheet.volumeFillState);
    const { x, y, anchor } = this.config.MenuBarContainer.soundControllerLineConfig;
    PixiBase.setPosition(this.soundControllerLine, { x: x, y: y });
    PixiBase.setPosition(this.volumeFillState, { x: x, y: y });
    this.soundControllerLine.anchor.set(anchor);
    this.volumeFillState.anchor.set(anchor);

    this.volumeFillStateGraphics = PixiBase.createGraphics();
    this.volumeFillStateGraphics.beginFill('red');
    this.volumeFillStateGraphics.drawRect(x - 4, y + (isMobile() ? 0 : 65), 8, 130);
    this.volumeFillStateGraphics.endFill();

    PixiBase.setMaskGraphicToContainer(this.graphicsContainerMask, this.volumeFillStateGraphics);
    PixiBase.setupButtonMode(this.soundControllerLine, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.soundControllerLine, this.onHandleClickOnLine.bind(this));
    PixiBase.registerPointerup(this.soundControllerLine, this.onHandleDragEnd.bind(this));
    this.graphicsContainerMask.addChild(this.volumeFillState);
    this.graphicsContainerMask.addChild(this.volumeFillStateGraphics);
    this.soundControllerWrapper.addChild(this.soundControllerLine);
    this.soundControllerWrapper.addChild(this.graphicsContainerMask);
  }

  setupSoundController() {
    this.soundController = PixiBase.createSprite(this.spriteSheet.soundController);
    const { x, y, anchor } = this.config.MenuBarContainer.soundControllerConfig;
    PixiBase.setPosition(this.soundController, { x: x, y: y });
    this.soundController.anchor.set(anchor);
    PixiBase.setupButtonMode(this.soundController, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.soundController, this.onHandleDragStart.bind(this));
    PixiBase.registerPointerup(this.soundController, this.onHandleDragEnd.bind(this));
    this.soundControllerWrapper.y = isMobile() ? -5 : 0;
    this.soundControllerWrapper.addChild(this.soundController);
    this.menuBarWrapperContainer.addChild(this.soundControllerWrapper);
    this.soundControllerWrapper.visible = false;
  }

  onHandleClickOnLine(event) {
    this.handleProgressMove(event);
    this.isDragging = false;
  }

  onHandleDragStart() {
    PixiBase.setupButtonMode(this.graphics, { interactive: true, buttonMode: true });
    PixiBase.setupButtonMode(this.soundControllerLine, { interactive: false, buttonMode: false });
    this.isDragging = true;
  }

  onHandleDragEnd(e) {
    this.isDragging = false;
    if (e.currentTarget !== this.soundController) {
      this.soundControllerWrapper.visible = false;
      PixiBase.setupButtonMode(this.graphics, { interactive: false, buttonMode: false });
    } else {
      PixiBase.setupButtonMode(this.soundControllerLine, { interactive: true, buttonMode: true });
    }
    userSettingsStore.setPrevSoundValue(userSettingsStore.soundValue);
  }

  handleProgressMove(event) {
    const newPosition = event.data.getLocalPosition(this.menuBarWrapperContainer);
    const clampedY = Math.max(
      this.soundRangeValues.Min,
      Math.min(newPosition.y, this.soundRangeValues.Max)
    );
    this.soundController.position.y = clampedY;

    const rangeValue =
      ((clampedY - this.soundRangeValues.Min) * (SOUND_RANGE_VALUE.Max - SOUND_RANGE_VALUE.Min)) /
      (this.soundRangeValues.Max - this.soundRangeValues.Min);
    const { y } = this.config.MenuBarContainer.soundControllerLineFillGraphics;
    const soundValue = Math.round(SOUND_RANGE_VALUE.Max - Math.abs(rangeValue));

    this.volumeFillStateGraphics.position.y =
      y -
      soundValue *
        ((this.soundRangeValues.Max - this.soundRangeValues.Min) /
          (SOUND_RANGE_VALUE.Max - SOUND_RANGE_VALUE.Min));
    userSettingsStore.setSoundValue(soundValue);
    const soundIcon = isMobile() ? frameNames.SoundIconMobile : frameNames.SoundIcon;
    const muteIcon = isMobile() ? frameNames.MuteIconMobile : frameNames.MuteIcon;
    PixiBase.changeFrame(this.soundIcon, soundValue > 0 ? soundIcon : muteIcon);
  }

  onHandleDragMove(event) {
    if (this.isDragging) {
      this.handleProgressMove(event);
    }
  }

  setupMenuBarPopup() {
    const menuBarPopupGraphics = PixiBase.createGraphics();
    menuBarPopupGraphics.beginFill('#121212');
    menuBarPopupGraphics.alpha = 1;
    menuBarPopupGraphics.drawRect(0, 0, 270, 810);
    menuBarPopupGraphics.endFill();
    this.menuBarPopupContainer.visible = false;
    this.menuBarPopupContainer.addChild(menuBarPopupGraphics);
    this.MenuBarContainer.addChild(this.menuBarPopupContainer);
  }

  setupInfoIcon() {
    this.payTableButtonContainer = PixiBase.createContainer('payTableButtonContainer');
    this.menuBarYellowLayer = PixiBase.createSprite(this.spriteSheet.menuBarYellowLayer);
    this.payTableIcon = PixiBase.createSprite(this.spriteSheet.infoIcon);
    this.payTableContainerGraphics = PixiBase.createGraphics();
    this.payTableContainerGraphics.beginFill('red');
    this.payTableContainerGraphics.alpha = 0;
    this.payTableContainerGraphics.drawRect(
      -44.5,
      -33,
      this.menuBarYellowLayer.width,
      this.menuBarYellowLayer.height
    );
    this.payTableIconText = PixiBase.createText(gameStore.canvasTranslationKeys.PAYTABLE, {
      fontSize: 17,
      fill: 'white',
      align: 'center',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });
    const { y, anchor, scale } = this.config.MenuBarContainer.payTableIconConfig;
    const { y: payTableIconTextY } = this.config.MenuBarContainer.payTableTextConfig;
    const { x: yellowX, y: yellowLayerY } = this.config.MenuBarContainer.menuBarYellowLayer;
    PixiBase.setPosition(this.menuBarYellowLayer, { x: yellowX, y: yellowLayerY });
    PixiBase.setPosition(this.payTableIcon, { y: y });

    PixiBase.setPosition(this.payTableIconText, {
      x: Math.floor(this.payTableIcon.width / 2),
      y: payTableIconTextY,
    });
    PixiBase.setupButtonMode(this.payTableContainerGraphics, {
      interactive: true,
      buttonMode: true,
    });
    this.payTableIconTextY = payTableIconTextY;
    PixiBase.registerClick(this.payTableContainerGraphics, () => {
      this.menuBarYellowLayer.y = this.iconsAndTextContainer.y + payTableIconTextY;
      gameMainDrawer.introBar.handleVisibilityContainersByName(
        containerNames.PayTableContainersWrapper
      );
    });
    this.payTableIcon.anchor.set(anchor);
    this.menuBarYellowLayer.anchor.set(anchor);
    this.payTableIconText.anchor.set(0, anchor);
    this.payTableIcon.scale.set(scale);
    this.payTableButtonContainer.addChild(this.payTableContainerGraphics);
    this.payTableButtonContainer.addChild(this.payTableIcon);
    this.payTableButtonContainer.addChild(this.payTableIconText);
    this.iconsAndTextContainer.addChild(this.payTableButtonContainer);
  }

  setIntroBarVisibleState() {
    if (menuBarStore.isMenuPopupOpen) {
      gameMainDrawer.layers.betBar.BetBarContainer.visible = false;
      gameMainDrawer.layers.spinBar.SpinBarContainer.visible = false;
      gameMainDrawer.layers.slotBar.SlotBarContainer.visible = false;
      gameMainDrawer.layers.slotBoard.SlotBoardContainer.visible = false;
      gameMainDrawer.layers.lineWinBar.LineWinBarContainer.visible = false;
      gameMainDrawer.layers.expandWildBar.ExpandWildBarContainer.visible = false;
    } else {
      gameMainDrawer.layers.betBar.BetBarContainer.visible = true;
      gameMainDrawer.layers.spinBar.SpinBarContainer.visible = true;
      gameMainDrawer.layers.slotBar.SlotBarContainer.visible = true;
      gameMainDrawer.layers.slotBoard.SlotBoardContainer.visible = true;
      gameMainDrawer.layers.lineWinBar.LineWinBarContainer.visible = true;
      gameMainDrawer.layers.expandWildBar.ExpandWildBarContainer.visible = true;
    }
  }

  setupSettingsIcon() {
    this.settingsButtonContainer = PixiBase.createContainer('settingsButtonContainer');
    this.settingsIcon = PixiBase.createSprite(this.spriteSheet.settingsIcon);
    this.settingsContainerGraphics = PixiBase.createGraphics();
    this.settingsContainerGraphics.beginFill('red');
    this.settingsContainerGraphics.alpha = 0;
    this.settingsContainerGraphics.drawRect(
      -44.5,
      38.5,
      this.menuBarYellowLayer.width,
      this.menuBarYellowLayer.height
    );
    this.settingsIconText = PixiBase.createText(gameStore.canvasTranslationKeys.SETTINGS, {
      fontSize: 17,
      fill: 'white',
      align: 'center',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });
    const { y, anchor, scale } = this.config.MenuBarContainer.settingsIconConfig;
    const { y: settingsIconTextY } = this.config.MenuBarContainer.settingsTextConfig;
    PixiBase.setPosition(this.settingsIcon, { y: y });
    PixiBase.setPosition(this.settingsIconText, {
      x: Math.floor(this.settingsIcon.width / 2),
      y: settingsIconTextY,
    });

    this.settingsIcon.anchor.set(anchor);
    this.settingsIconText.anchor.set(0, anchor);
    this.settingsIcon.scale.set(scale);
    PixiBase.setupButtonMode(this.settingsContainerGraphics, {
      interactive: true,
      buttonMode: true,
    });
    PixiBase.registerClick(this.settingsContainerGraphics, () => {
      gameMainDrawer.introBar.handleVisibilityContainersByName(containerNames.SettingsBarContainer);
      this.menuBarYellowLayer.y = this.iconsAndTextContainer.y + settingsIconTextY;
    });
    this.settingsButtonContainer.addChild(this.settingsContainerGraphics);
    this.settingsButtonContainer.addChild(this.settingsIcon);
    this.settingsButtonContainer.addChild(this.settingsIconText);
    this.iconsAndTextContainer.addChild(this.settingsButtonContainer);
  }

  setupGameRulesIcon() {
    this.gameRulesButtonContainer = PixiBase.createContainer('gameRulesButtonContainer');
    this.gameRulesIcon = PixiBase.createSprite(this.spriteSheet.gameRulesIcon);
    this.gameRulesContainerGraphics = PixiBase.createGraphics();
    this.gameRulesContainerGraphics.beginFill('red');
    this.gameRulesContainerGraphics.alpha = 0;
    this.gameRulesContainerGraphics.drawRect(
      -44.5,
      38.5,
      this.menuBarYellowLayer.width,
      this.menuBarYellowLayer.height
    );
    this.gameRulesContainerGraphics.endFill();
    this.gameRulesButtonContainer.addChild(this.gameRulesContainerGraphics);

    this.gameRulesIconText = PixiBase.createText(gameStore.canvasTranslationKeys.GAME_RULES, {
      fontSize: 18,
      fill: '#FFFFFF',
      align: 'center',
      fontWeight: 500,
      fontFamily: 'Roboto',
    });
    const { y, anchor, scale } = this.config.MenuBarContainer.rulesIconConfig;
    const { y: gameRulesIconTextY } = this.config.MenuBarContainer.rulesTextConfig;
    PixiBase.setPosition(this.gameRulesIcon, { y: y });
    PixiBase.setPosition(this.gameRulesIconText, {
      x: Math.floor(this.gameRulesIcon.width / 2),
      y: gameRulesIconTextY,
    });
    this.gameRulesIcon.anchor.set(anchor);
    this.gameRulesIconText.anchor.set(0, anchor);
    this.gameRulesIcon.scale.set(scale);
    PixiBase.setupButtonMode(this.gameRulesContainerGraphics, {
      interactive: true,
      buttonMode: true,
    });
    this.gameRulesButtonContainer.addChild(this.gameRulesIcon);
    this.gameRulesButtonContainer.addChild(this.gameRulesIconText);

    PixiBase.registerClick(this.gameRulesContainerGraphics, () => {
      gameMainDrawer.introBar.handleVisibilityContainersByName(containerNames.GameRulesContainer);
      this.menuBarYellowLayer.y = this.iconsAndTextContainer.y + gameRulesIconTextY;
    });
    this.iconsAndTextContainer.addChild(this.gameRulesButtonContainer);
    this.menuBarPopupContainer.addChild(this.menuBarYellowLayer);
    this.menuBarPopupContainer.addChild(this.iconsAndTextContainer);
  }

  setupMenuWrapperShadow() {
    this.menuWrapperShadow = PixiBase.createSprite(this.spriteSheet.bottomShadow);
    const { x, y, anchor } = this.config.MenuBarContainer.menuWrapperShadowConfig;
    if (isMobile()) {
      this.menuWrapperShadow.scale.set(1.85);
    }
    PixiBase.setPosition(this.menuWrapperShadow, { x: x, y: y });
    this.menuWrapperShadow.anchor.set(anchor);
    this.menuBarWrapperContainer.addChild(this.menuWrapperShadow);
  }

  setupGameDate() {
    this.dateContainer = PixiBase.createContainer(containerNames.DateContainer);
    this.timeIcon = PixiBase.createSprite(this.spriteSheet.timeIcon);
    this.dateText = PixiBase.createText('', {
      fontSize: 14,
      fill: '#FFFFFF',
      align: 'center',
      fontWeight: 300,
      fontFamily: 'Roboto',
    });
    const { x, y } = this.config.MenuBarContainer.dateContainerConfig;
    const { y: timeIconY } = this.config.MenuBarContainer.timeIconConfig;
    const { x: dateTextX } = this.config.MenuBarContainer.dateTextConfig;
    PixiBase.setPosition(this.dateContainer, { x: x, y: y });
    PixiBase.setPosition(this.timeIcon, { y: timeIconY });
    PixiBase.setPosition(this.dateText, { x: dateTextX });
    this.dateContainer.addChild(this.timeIcon);
    this.dateContainer.addChild(this.dateText);
    this.menuBarWrapperContainer.addChild(this.dateContainer);
    this.updateGameDate(this.dateText.text);
  }

  updateGameDate = () => {
    setInterval(() => {
      this.dateText.text = updateDate();
    }, 1000);
  };

  setupGameLogoInMenuBarPopup() {
    this.menuLogo = new Spine({ key: 'logo' });
    this.menuLogo.play('animation', true);
    this.menuLogo.scale.set(0.6);
    const { x, y } = this.config.MenuBarContainer.menuGameLogo;
    PixiBase.setPosition(this.menuLogo, { x: x, y: y });
    this.menuBarPopupContainer.addChild(this.menuLogo);
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    const {
      MenuBarContainer: {
        menuBarPopupContainerConfig,
        iconsAndTextContainerConfig,
        menuBarWrapperContainerConfig,
      },
    } = this.config;
    setContainersPosition(this.menuBarPopupContainer, menuBarPopupContainerConfig);
    setContainersPosition(this.iconsAndTextContainer, iconsAndTextContainerConfig);
    setContainersPosition(this.menuBarWrapperContainer, menuBarWrapperContainerConfig);
    !isMobile() && this.setupMenuBarPopup();
    this.setupMenuWrapperShadow();
    if (!isMobile()) {
      this.setupGameLogoInMenuBarPopup();
      this.setupInfoIcon();
      // this.setupSettingsIcon();
      this.setupGameRulesIcon();
      this.setupMenuBarWrapper();
      this.setupGameDate();
    }
    this.setupSoundProgressControllerGraphicsForMouseMove();
    this.setupSoundControllerLine();
    this.setupSoundController();
    !isMobile() && this.setupFullScreenIcon();
    this.setupBalanceText();
    this.setupBalanceAmount();
    this.setupOpenMenuIcon();
    this.setupSoundIcon();
    if (isMobile()) {
      this.createMobileIntroView();
    }
  }
}
